<template>
  <div>
    <!-- izbor prizvoda -->
    <div v-show="!unos_podataka">
      <!-- filtar proizvoda -->
      <b-field label="Врста паркинг карте">
        <b-select
          expanded
          :disabled="false"
          v-model="vrsta_karte_filtar"
          @input="onTipKarteChanged"
        >
          <option value="">Све врсте карата</option>
          <option value="DK">Дневне паркинг карте</option>
          <option value="PK">Месечне и годишње паркинг карте</option>
        </b-select>
      </b-field>
      <!-- <br /> -->
      <!-- lista proizvoda -->
      <!-- <div class="section is-clearfix">
        <div
          class="box"
          style="width: 360px; float: left;"
          v-for="stavka in dajStavkeCenovnikaPoVrstiKarte(
            this.vrsta_karte_filtar
          )"
          :key="stavka.id"
          :value="stavka.id"
        >
          <p>
            {{ stavka.naziv_karte }}

            <br />
            <span class="has-text-weight-bold">{{ stavka.cena }} дин</span>

            <b-button class="is-pulled-right" @click="onKupiClick(stavka.id)"
              >Купи</b-button
            >
          </p>
        </div>
      </div> -->

      <div class="columns is-multiline">
        <div
          class="column is-one-third-desktop is-half-tablet "
          v-for="stavka in dajStavkeCenovnikaPoVrstiKarte(
            this.vrsta_karte_filtar
          )"
          :key="stavka.id"
          :value="stavka.id"
        >
          <div class="box">
            <p>
              {{ stavka.naziv_karte }}

              <br />
              <span class="has-text-weight-bold">{{ stavka.cena }} дин</span>

              <b-button
                class="is-pulled-right"
                @click="onKupiClick(stavka.id)"
                :disabled="izmenaZabranjena"
                >Купи</b-button
              >
            </p>
          </div>
        </div>
      </div>

      <!-- <div class="columns is-multiline">
        <div class="column is-one-third-desktop is-half-tablet">
          <div class="box">xxx</div>
        </div>
        <div class="column is-one-third-desktop is-half-tablet">
          <div class="box">xxx</div>
        </div>
        <div class="column is-one-third-desktop is-half-tablet">
          <div class="box">xxx</div>
        </div>
      </div> -->

      <!-- navigation -->
      <div class="columns">
        <div class="column">
          <b-button
            class="is-pulled-right"
            tag="router-link"
            :to="{
              path: '/kupovina',
              query: { step: '1' }
            }"
            >&gt;&gt;</b-button
          >
        </div>
      </div>
    </div>
    <!-- unos podataka prizvoda -->
    <div v-show="unos_podataka">
      <DnevnaParkingKartaForma
        v-show="unosDnevneKarte"
        v-on:proizvodDodat="onProizvodDodat"
        v-on:nazad="onUnosFormaNazad"
      />
      <MesecnaPretplataForma
        v-show="!unosDnevneKarte"
        :resetujPodatke="resetujPodatkeTrigger"
        :idKarte.sync="id_karte"
        v-on:proizvodDodat="onProizvodDodat"
        v-on:nazad="onUnosFormaNazad"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import DnevnaParkingKartaForma from '../components/DnevnaParkingKartaForma'
import MesecnaPretplataForma from '../components/MesecnaPretplataForma'

export default {
  components: {
    DnevnaParkingKartaForma,
    MesecnaPretplataForma
  },
  data() {
    return {
      vrsta_karte_filtar: null,
      unos_podataka: false,
      id_karte: '',
      resetujPodatkeTrigger: false
    }
  },
  created() {
    this.$store.dispatch('placanje/dajCenovnik')
    //console.log(this.$route.query.tip_karte)
    this.vrsta_karte_filtar = this.$route.query.vrsta_karte
  },
  // beforeRouteUpdate not fired in a child component
  // https://github.com/vuejs/vue-router/issues/1782
  // resenje je watch (dole)
  // beforeRouteUpdate(to, from, next) {
  //   this.vrsta_karte_filtar = this.$route.query.vrsta_karte
  //   next()
  // },
  methods: {
    onTipKarteChanged(value) {
      console.log(value)
    },
    onKupiClick(stavkaId) {
      console.log(stavkaId)
      this.id_karte = stavkaId
      this.unos_podataka = true
      // ovo okida funkciju resetuj podatke u child komponenti
      // https://stackoverflow.com/questions/55316490/vue-best-practice-for-calling-a-method-in-a-child-component/55317353
      this.resetujPodatkeTrigger = !this.resetujPodatkeTrigger
    },
    onProizvodDodat() {
      console.log('onProizvodDodat')
      this.unos_podataka = false
      this.id_karte = ''
      this.$buefy.snackbar.open('Карта је додата у корпу')
    },
    onUnosFormaNazad() {
      this.unos_podataka = false
      this.id_karte = ''
    }
  },
  computed: {
    unosDnevneKarte() {
      return this.id_karte.substring(0, 2) === 'DK'
    },
    ...mapState('placanje', ['cenovnik']),
    ...mapGetters('placanje', [
      'dajStavkeCenovnikaPoVrstiKarte',
      'izmenaZabranjena'
    ])
  },
  watch: {
    $route() {
      console.log(this.$route.query)
      this.vrsta_karte_filtar = this.$route.query.vrsta_karte
    }
  }
}
</script>

<style></style>
